/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProductsByUserAliases {
  ACCESSIBILITY = 'accessibility',
  APPLICATION_BAR = 'application-bar',
  CONTEXTUAL_BAR = 'contextual-bar',
  DECK = 'deck',
  FETCH_DECK = 'fetch-deck',
  FIELD_ANS = 'field-Ans',
  FIELD_CONTRACTING_TYPE = 'field-ContractingType',
  FIELD_COVERAGE = 'field-Coverage',
  FIELD_FILTER = 'field-filter',
  FIELD_PLAN = 'field-Plan',
  FIELD_SEGMENTATION = 'field-Segmentation',
  FIELD_SITUATION = 'field-Situation',
  FORM_FILTER = 'form-filter',
  FRAGMENT_FOOTER = 'fragment-footer',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  INPUT_FILTER = 'input-filter',
  PANEL_0 = 'panel-0',
  PANEL_ACCESSIBILITY = 'panel-accessibility',
  PANEL_CONTENT = 'panel-content',
  PANEL_DECK = 'panel-deck',
  PANEL_FORM = 'panel-form',
  ROOT_COMPONENT = 'root-component',
  TEXT_ANS = 'text-Ans',
  TEXT_CONTRACTING_TYPE = 'text-ContractingType',
  TEXT_COVERAGE = 'text-Coverage',
  TEXT_PLAN = 'text-Plan',
  TEXT_SEGMENTATION = 'text-Segmentation',
  TEXT_SITUATION = 'text-Situation',
}
export { ProductsByUserAliases };
